import isEmpty from 'lodash/isEmpty'

import { useIntl } from 'react-intl'
import { DATETIME_SHORT, formatTime } from 'app/utils/formatDate'

import { SubscriptionHistoryConfig } from '../types'
//import { getHistoryPlanAndName } from '../utils'
import {
  HistoryCard,
  HistoryCardRow,
  HistoryFlexRow,
  HistoryLabel,
  SubscriptionHistoryPlanLabel,
} from './styles'
import { subscriptionHistoryMessages } from './messages'
import { SubscriptionHistoryPlanIcon } from 'components/Icons/SubscriptionIcon'
import { makePublicUrl } from 'app/utils/publicUrl'
import { CardNumber, Last4Digits, PaymentSystem } from 'components/Card/styles'

interface Props {
  values: Record<string, any>
}

const MobileHistoryViewComponent = (props: Props) => {
  const history = props.values as SubscriptionHistoryConfig
  const { formatMessage } = useIntl()
  //const { planName: planHistoryName, status } = getHistoryPlanAndName(
  //history.planName
  //)

  return (
    <HistoryCard>
      <HistoryCardRow>
        <HistoryFlexRow>
          <SubscriptionHistoryPlanIcon
            status={history.event}
            planName={history.planName}
          />
          <SubscriptionHistoryPlanLabel>
            {history.description}
          </SubscriptionHistoryPlanLabel>
        </HistoryFlexRow>
      </HistoryCardRow>
      <HistoryCardRow>
        <HistoryLabel>
          {formatMessage(subscriptionHistoryMessages.dateActivateLabel)}
        </HistoryLabel>
        <HistoryLabel>
          {history.date ? formatTime(history.date, DATETIME_SHORT) : ''}
        </HistoryLabel>
      </HistoryCardRow>
      <HistoryCardRow>
        <HistoryLabel>
          {formatMessage(subscriptionHistoryMessages.paymentInfoLabel)}
        </HistoryLabel>
        <CardNumber>
          <>
            {history?.paymentInfo && !isEmpty(history?.paymentInfo) ? (
              <>
                <PaymentSystem
                  src={makePublicUrl(
                    `images/paymentLogos/${history?.paymentInfo.cardBrand}.svg`
                  )}
                  alt={history?.paymentInfo.cardBrand}
                />
                <Last4Digits
                  isNonBold
                  isSmallFont
                >{`**** ${history?.paymentInfo.last4}`}</Last4Digits>
              </>
            ) : (
              '-'
            )}
          </>
        </CardNumber>
      </HistoryCardRow>
      <HistoryCardRow>
        <HistoryLabel>
          {formatMessage(subscriptionHistoryMessages.renewalExpirationDate)}
        </HistoryLabel>
        <HistoryLabel>{history.canceledAt}</HistoryLabel>
      </HistoryCardRow>
    </HistoryCard>
  )
}

export default MobileHistoryViewComponent
